import { Attachment } from '@billy/design-system'

import { AttachmentFillType } from '@features/attachments/enums/attachmentFillType'
import { useFetchAttachments } from '@features/attachments/hooks/useFetchAttachments'

import { useOrgUsesReceiptsOnly } from '../../../hooks/useOrgUsesReceiptsOnly'
import { SHOEBOX_ATTACHMENTS_INCLUDE } from '../constants/shoeboxAttachmentsInclude'

interface UseDuplicateAttachmentsResponse {
  duplicates: Attachment[]
  isLoading: boolean
}

export const useDuplicateAttachments = (): UseDuplicateAttachmentsResponse => {
  const orgUsesReceiptsOnly = useOrgUsesReceiptsOnly()

  const { attachments, isLoading } = useFetchAttachments({
    isDuplicate: true,
    fillType: orgUsesReceiptsOnly ? undefined : AttachmentFillType.Nonfilled,
    include: orgUsesReceiptsOnly ? SHOEBOX_ATTACHMENTS_INCLUDE : undefined,
  })

  return {
    duplicates: attachments,
    isLoading,
  }
}
